
import { useEffect, useRef, useState } from "react";
import Dialog from "./Dialog";

interface DialogFormProps {
  submitForm: (form: HTMLFormElement) => void;
  open: boolean;
  onClose: () => void;
  onError: (string) => void;
  title?: string;
  primaryButtonText?: string;
  secondaryButtonAction?: () => void;
  secondaryButtonText?: string;
  fullWidth?: boolean;
  testId?: string;
  children: React.ReactNode;
}

const DialogForm = ({
  submitForm,
  open,
  onClose,
  onError,
  title,
  primaryButtonText,
  secondaryButtonAction,
  secondaryButtonText,
  fullWidth,
  testId,
  children
}: DialogFormProps) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const isSubmittingRef = useRef(false);
  const formRef = useRef<HTMLFormElement>(null)

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    await submitFormWithDebounce();
  }

  const enableFormSubmission = () => {
    isSubmittingRef.current = false
    setIsSubmitting(false)
  }

  const submitFormWithDebounce = async () => {
    const form = formRef.current;
    if (!form) return;
    if (isSubmittingRef.current) return;
    isSubmittingRef.current = true
    setIsSubmitting(true)
    try {
      await submitForm(form)
      onClose();
    } catch (error: any) {
      onError(error.message)
      enableFormSubmission();
    }
  }

  useEffect(() => {
    if (open) {
      enableFormSubmission();
    }
  }, [open])

  return <>
    <Dialog
      open={open}
      onClose={onClose}
      title={title}
      primaryButtonAction={submitFormWithDebounce}
      primaryButtonText={primaryButtonText}
      primaryButtonDisabled={isSubmitting}
      secondaryButtonAction={secondaryButtonAction}
      secondaryButtonText={secondaryButtonText}
      fullWidth={fullWidth}
      testId={testId}
    >
      <form
        onSubmit={handleSubmit}
        role="form"
        ref={formRef}
      >
        {children}
      </form>
    </Dialog>
  </>
}

export default DialogForm;